import React from "react";
import Advice from './Component/Advice';

import "./App.css";

function App() {
  return (
    <div className="app">
      <h1 className="title">Advice App</h1>
      <Advice />
    </div>
  );
}

export default App;
